import React from "react";
import { Box } from "@mui/material";

const Greeting = ({ user = "User" }) => {
  // Function to determine greeting based on the time of day
  const getGreeting = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 0 && currentHour < 12) {
      return "Good Morning";
    } else if (currentHour >= 12 && currentHour < 17) {
      return "Good Afternoon";
    } else if (currentHour >= 17 && currentHour < 21) {
      return "Good Evening";
    } else {
      return "Good Night";
    }
  };

  return (
    <Box sx={{ fontSize: "1.2rem" }}>
      <p>
        {getGreeting()}, {user}
      </p>
    </Box>
  );
};

export default Greeting;
